import { Mockup } from '@interfaces/mockup.interface';

export const SECURITY_KEY_STATUS_MOCK: Mockup = {
  success: [{
    response: {
      status: 'Activa',
      statusCode: '03'
    }
  }],
  failures: [{
    response: {
      code: 500,
      message: 'Error',
      messageDescription: 'Error obteniendo estado de la contraseña',
    }
  }]
};
